import type { SavedFilterStructure } from '@/Atomic/Organisms/FilterBuilder'

/**
 * Codec for the `?query=` URL param — the applied-but-unsaved advanced filter.
 *
 * The param is the single source of truth for that filter, so encode/decode must
 * be identical everywhere it is read or written (list header, FilterBuilder
 * modals, AiChatBot `show_filter_preview` / `save_filter` / `get_current_page`).
 * Padding is stripped: PISA rejects `=` in the query param.
 */

const isFilterStructure = (value: unknown): value is SavedFilterStructure =>
  typeof value === 'object' &&
  value !== null &&
  'or' in value &&
  Array.isArray(value.or)

export const encodeFilterQuery = (structure: SavedFilterStructure): string =>
  btoa(JSON.stringify(structure)).replaceAll('=', '')

/** Returns `undefined` for an absent, malformed, or non-filter payload. */
export const decodeFilterQuery = (
  query: string | null | undefined,
): SavedFilterStructure | undefined => {
  if (!query) return undefined
  try {
    // Re-pad — historic writers kept the `=` padding, current ones strip it.
    const padded = query.padEnd(Math.ceil(query.length / 4) * 4, '=')
    const parsed: unknown = JSON.parse(atob(padded))
    return isFilterStructure(parsed) ? parsed : undefined
  } catch {
    return undefined
  }
}
